<template>
  <div class="row align-items-center my-5">
    <div v-for="model in props.models" class="col-lg-3 col-12" :key="model.id">
      <NuxtLink :to="{name: 'language-modelos-name-photo', params: {name: model.slug}}">
        <div class="card-pagination pr-3">
          <img
            :src="`${model.cover}`"
            :alt="model.imageAltText ?? model.title"
            width="290"
            height="213"
          />
          <div class="card-body d-flex flex-column align-items-center">
            <h5 class="card-title my-3">{{ model.title }}</h5>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Model {
  id: number;
  title: string;
  slug: string;
  cover: string;
  imageAltText?: string;
}
const props = defineProps({
  models: {
    type: Array<Model>,
    required: true,
  },
});
</script>

<style scoped lang="css">
.card-title {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}

.card-pagination img {
  width: 100%;
  object-fit: cover;
  height: auto;
}

.card-pagination {
  background-color: transparent;
  cursor: pointer;
}
</style>
